<template>
  <section>
      <alert id="popup-error" type="warning" v-if="hasAlert"  dismissible @dismissed="hasAlert = false">
          <ul class="property" v-for="item in content">
            <li class="item">{{ item }}</li>
          </ul>
      </alert>
  </section>
</template>
<script>

  import { bus } from '../main';
  import { Alert } from 'uiv'
  export default {
    data () {
      return {
        hasAlert: false,
        content: null,
        title: null
      }
    },

    props: { },
    computed: { },
    components: { Alert },

    methods: {
      showAlert (data) {
        this.hasAlert = true;
        this.content = data.content;
      }
    },
    mounted: function() {
      // listen for the alert event on the eventHub (main)
      bus.$on('alert', (item) => {
        this.showAlert(item.data);
      });

      bus.$on('reset', (item) => {
        this.hasAlert = false;
      });
    }
  }
</script>


<style scoped lang="scss">
@import "../css/constants";
ul.property { padding: 3px 0; margin-left: 10px; \list-style-type: circle; }
ul.property li { margin-left: 5px; }

</style>


// WEBPACK FOOTER //
// src/components/Popups.vue